import * as ActionConstants from "../constants/ReduxConstants";

export const ManagePrinters = (state = [], action) => {
  switch (action.type) {
    case ActionConstants.GET_MANAGE_PRINTERS_LIST:
      return action.data;

    default:
      return state;
  }
};

export const ManageUnNamedPrinters = (state = [], action) => {
  switch (action.type) {
    case ActionConstants.GET_MANAGE_UNNAMED_PRINTERS_LIST:
      return action.data;

    default:
      return state;
  }
};
